import {httpRequest} from "../../../utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {ICustomerSearch,ICustomerParams,ICustomerDetail,ICustomerInsert,ICustomerUpdata,ICustomerDisable,ShareUser,ShareShop} from "./customerTypes"
class CustomerService {
    async page(params:ICustomerSearch){
        const apiUrl = "/md/customer/page"
        return await httpRequest.post<IPage<ICustomerDetail>>(apiUrl,params)
    }
    async insert(params:ICustomerInsert){
        const apiUrl = "/md/customer/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:ICustomerUpdata){
        const apiUrl = "/md/customer/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:ICustomerDisable){
        const apiUrl = "/md/customer/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async shareShop(params:ShareShop){ //共享门店
        const apiUrl = "/md/customer/shareShop"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async shareUser(params:ShareUser){ //共享门店
        const apiUrl = "/md/customer/shareUser"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const customerService = new CustomerService()
export {
    customerService
}